import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { questionShape } from "utils/propTypeShapes"
import TextLinkDecorator from "components/shared/TextLinkDecorator"

const NoteAnswerField = ({
  className = "",
  initialValue = null,
  question,
}) => {
  const { attributes: { note }, uuid } = question

  return (
    <div className={clsx(className)}>
      <TextLinkDecorator
        name={uuid}
        value={note || initialValue}
        className="formatted-note-contained"
      />
    </div>
  )
}

NoteAnswerField.propTypes = {
  question: questionShape.isRequired,
  initialValue: types.string,
  className: types.string,

}

export default NoteAnswerField
